import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Badge, ListGroupItem, ListGroupItemHeading } from 'reactstrap';
import { toLocalTime } from '../../utils/helper';

const getTypeText = ({ type, text }) => {
  switch (type) {
    case 'audio': return <FormattedMessage id="chats_chat_voiceMessage" />;
    case 'image': return <FormattedMessage id="chats_chat_imageAttached" />;
    case 'video': return <FormattedMessage id="chats_chat_videoAttached" />;
    case 'document': return <FormattedMessage id="chats_chat_documentAttached" />;
    case 'message': return <FormattedMessage id="chats_chat_forwardedMessage" />;
    case 'shared_note': return <FormattedMessage id="chats_chat_sharedNote" />;
    default: return text;
  }
};

const ChatItem = ({ id, title, datetime, last_message, file_link, count, handleClick }) => (
  <ListGroupItem className="chat_item">
    <Link to={`/trainings/chats/${id}`} onClick={ev => handleClick && handleClick(ev)}>
      <ListGroupItemHeading>{file_link && (
        <img src={file_link} alt="" style={{ maxWidth: 64, maxHeight: 64 }} />)}
        {count ? <Badge pill>{count}</Badge> : <span />}
      </ListGroupItemHeading>
      <div className="chat_title">{title}</div>
      <div className="chat_date">{last_message && toLocalTime(datetime)}</div>
      <div>{last_message && getTypeText(last_message)}</div>
    </Link>
  </ListGroupItem>
);

ChatItem.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  datetime: PropTypes.string.isRequired,
  last_message: PropTypes.objectOf(PropTypes.any),
  file_link: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  count: PropTypes.number.isRequired,
  handleClick: PropTypes.func,
};

export default ChatItem;



// WEBPACK FOOTER //
// ./src/views/_Chats/ChatItem.js